// extracted by mini-css-extract-plugin
export default {"textField":"textField---Spzje","copyControl":"copyControl---LIAej"};